const m = require('air-vue-model')()
m.url = 'product_outlets'
m.name = 'productOutlet'

module.exports = m